import Phaser from 'phaser';
import { CST } from '../CST.js';
import $ from 'jquery';
import { hideTextFields, showTextFields } from '../helpers/text-fields';
import buttonBehaviours from '../helpers/button-behaviours';

export default class LicenseExpiredOverlay extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.LICENSEEXPIRED);
	}

	init(data) {
		this.isOrg = data?.isOrg ?? false;
	}

	preload() {
		this.load.image('bg-license', 'assets/bg-license.png');
		this.load.image('bg-license-org', 'assets/bg-license-org.png');
		this.load.image('btn-buy-now', 'assets/btn-buy-now.png');
		this.load.image('btn-submit', 'assets/btn-submit.png');
		this.load.image('back_btn', 'assets/english/go-backwards.png');
		this.load.image('error-code', 'assets/english/error/error-code.png');
		this.load.image('error-empty-field', 'assets/english/error/error-empty-field.png');
		this.load.image('error-generic', 'assets/english/error/error-generic.png');
		this.load.image('message-success', 'assets/english/error/message-success.png');
		this.load.html('html-product-code', 'html/product-code.html');
	}

	async create() {
		this.sndClick = this.sound.add('clickSound');
		this.scene.bringToTop();

		if (this.isOrg) {
			this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bg-license-org');
			this.btnBack = this.add
				.image(90, this.cameras.main.height / 2 + 410, 'back_btn')
				.setInteractive({ useHandCursor: true })
				.on('pointerdown', () => {
					this.sndClick.play();
					buttonBehaviours.pushOnClick(this, this.btnBack, () => {
						this.scene.start(CST.SCENES.LOGIN);
					});
				})
				.setScale(1.5);
			return;
		}

		this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bg-license');

		this.btnBuy = this.add
			.image(this.cameras.main.width / 2 + 120, this.cameras.main.height / 2 + 205, 'btn-buy-now')
			.setInteractive({ useHandCursor: true })
			.on('pointerup', () => {
				this.sndClick.play();
				window.open(
					'https://shop.focusgames.com/products/leadership-roulette?_pos=3&_psq=leadership&_ss=e&_v=1.0',
					'_blank',
				);
			});

		this.code = this.add
			.dom(this.cameras.main.width / 2, this.cameras.main.height / 2 + 130)
			.createFromCache('html-product-code');
		this.code = this.code.getChildByName('productCode');

		this.btnSubmit = this.add
			.image(this.cameras.main.width / 2 - 120, this.cameras.main.height / 2 + 205, 'btn-submit')
			.setInteractive({ useHandCursor: true })
			.on('pointerup', () => {
				this.sndClick.play();
				this.btnSubmit.disableInteractive();
				this.redeem();
			});
	}

	upload() {}

	async redeem() {
		let self = this;

		$.ajax({
			async: false,
			type: 'post',
			url: 'website/renew-license.php',
			headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` },
			data: {
				code: this.code.value,
			},
			dataType: 'JSON',
			success(response) {
				if (response[0] === 400) {
					hideTextFields([self.code]);
					buttonBehaviours.disableInteraction([self.btnBuy, self.btnSubmit]);

					const error = self.add.image(
						self.cameras.main.width / 2,
						self.cameras.main.height / 2 - 175,
						response[1],
					);

					setTimeout(() => {
						showTextFields([self.code]);
						buttonBehaviours.enableInteraction([self.btnBuy, self.btnSubmit]);

						error.destroy();
					}, 2000);
				} else {
					hideTextFields([self.code]);
					buttonBehaviours.disableInteraction([self.btnBuy, self.btnSubmit]);
					self.add.image(
						self.cameras.main.width / 2,
						self.cameras.main.height / 2 - 175,
						response[1],
					);
					setTimeout(() => {
						self.scene.start(CST.SCENES.MENU);
					}, 2000);
				}
			},
			error(error) {
				console.log(error);
			},
		}).responseJSON;
	}
}
